import { connect } from 'react-redux';
import { createRule, ruleIsSubmitting, fetchRules, clearErrorOnCreateRule } from '../../actions/index';
import CreateRule from '../../components/CreateRule/CreateRule';

const mapStateToProps = state => {
    return {
        rules: state.rules,
        ruleSubmitting: state.ruleSubmitting,
        error: state.errorOnRuleCreation  ,
        invalidWorktags: state.validateWorkTags
    };
};

export default connect(
    mapStateToProps,
    { createRule, fetchRules, clearErrorOnCreateRule, ruleIsSubmitting }
)(CreateRule);


// WEBPACK FOOTER //
// ./src/containers/CreateRule/CreateRuleContainer.js